import { forwardRef, type SVGProps } from 'react';

/**
 * BrandSymbol — AXI Works 심볼마크 (2026-09-01).
 *
 * 출처 — 디자인 재료함 `logos:axiworks-symbol.svg-axi-works`
 *   「axiworks-symbol.svg · AXI Works 정본 심볼」(12차 B계열 확정).
 *   레포의 `assets/brand/axiworks-symbol.svg` 와 **바이트까지 같다**(2026-09-01 대조: 760자 일치).
 *   Pretendard Black 의 X 를 팔 중심선 실측(위 0.1575w · 아래 0.8544w)으로 갈라
 *   민트 몸체 + 파랑 그라디언트 팔로 만든 것이다.
 * 그 마크업을 **그대로 인라인**했다 — 요청 0회 · 오프라인 동작 · `currentColor` 없이 제 색을 쓴다.
 * ⚠ **여기 path·색을 손으로 고치지 말 것.** 고쳐야 하면 재료함 항목을 바꾸고 다시 가져온다.
 *
 * ★★ **그라디언트·클립 id 를 접두했다**(`axi-sym-*`). 원본의 id 는 `xyc`·`xycg` 라
 *    한 화면에 다른 SVG 가 같은 짧은 id 를 쓰면 **엉뚱한 그림이 칠해진다**
 *    (파일유형 글리프에서 실제로 겪은 일 — Word 가 Excel 색으로 칠해졌다).
 *
 * ★ **심볼 단독은 자리가 정사각형일 때만 쓴다**(디자인 정본 F0). 워드마크 자리에 심볼만
 *   넣으면 그건 로고가 아니라 아이콘이다.
 *
 * 색 — 몸체 Mint `#80D0D0` · 팔 Blue `#3B82F6` → Blue Deep `#1D4ED8`.
 * 브랜드 정본 값이라 테마 토큰으로 바꾸지 않는다(회사 테마를 바꿔도 브랜드는 그대로다).
 */
export const BrandSymbol = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(function BrandSymbol(
  { width = 40, height = 40, ...rest },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 143 143"
      width={width}
      height={height}
      role="img"
      aria-label="AXI Works"
      {...rest}
    >
      <title>AXI Works</title>
      <defs>
        <clipPath id="axi-sym-clip">
          <path
            transform="translate(2.963 0) scale(1.43) translate(-4.006 100)"
            d="M34.53 -100L51.381 -70.166L52.21 -70.166L69.337 -100L98.757 -100L68.785 -50L99.862 0L69.751 0L52.21 -30.249L51.381 -30.249L33.978 0L4.006 0L34.807 -50L4.972 -100L34.53 -100"
          />
        </clipPath>
        <linearGradient id="axi-sym-grad" x1="0" y1="0" x2=".9" y2="1">
          <stop offset="0" stopColor="#3B82F6" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      <g clipPath="url(#axi-sym-clip)">
        <rect width="143" height="143" fill="#80D0D0" />
        <path d="M-13.343 0 L62.447 0 L157.974 143 L82.184 143Z" fill="url(#axi-sym-grad)" />
      </g>
    </svg>
  );
});
